import { observer } from 'mobx-react';
import { PROFILER_SEARCH_CATEGORY_FIELDS } from '../../../../utils/constants/fields';
import MultiSelect from '../../../../components/inputs/MultiSelect';
import { useStore } from '../../../../store/store';
import { ICON_BUTTON_ICONS } from '../../../../components/buttons/IconButton';
import BulkFileDropzone, { BULK_DEMO_UPLOAD_HINT } from './BulkFileDropzone';

const ProfilerCompanyBulkSearchFormMobile = observer(
  ({
    searchTypeInput,
    onSearch,
    file,
    onFileChange,
    categoryFields,
    setCategoryFieldValue,
    categoryOptions,
    loading = false,
    progress = null
  }) => {
    const { utilsStore, profilerAccessStore } = useStore();
    if (utilsStore.windowWidth > 1200) {
      return null;
    }

    return (
      <div className="formform mobile">
        {profilerAccessStore.isProfilerDemo && (
          <div
            className={`profiler-demo-info-message${
              profilerAccessStore.demoSearchExceededLimit ? ' exceeded' : ''
            }`}
          >
            <div className="img-wrap">
              <img src={ICON_BUTTON_ICONS.EXCLAMATAION_CIRCLE} />
            </div>
            <div className="text">
              {profilerAccessStore.demoSearchExceededLimit ? (
                <>
                  You&apos;ve used all {profilerAccessStore.demoSearchMaxCount} demo searches -
                  upgrade to full access to continue exploring.
                </>
              ) : (
                <>
                  You have {profilerAccessStore.demoSearchRemainingCount} out of{' '}
                  {profilerAccessStore.demoSearchMaxCount} demo searches remaining - upgrade to full
                  access to unlock unlimited searches.
                </>
              )}
            </div>
          </div>
        )}
        <div className="mobile-search-form-title">Select search type of preference</div>
        {searchTypeInput}
        <MultiSelect
          field={PROFILER_SEARCH_CATEGORY_FIELDS.SEARCH_CATEGORY_MOBILE}
          value={categoryFields[PROFILER_SEARCH_CATEGORY_FIELDS.SEARCH_CATEGORY_MOBILE.NAME]}
          setFieldValue={setCategoryFieldValue}
          values={categoryOptions}
          disabled={loading}
        />
        <BulkFileDropzone
          file={file}
          onFileChange={onFileChange}
          loading={loading}
          progress={progress}
          disabled={profilerAccessStore.isProfilerDemo}
          disabledHint={BULK_DEMO_UPLOAD_HINT}
        />
        <button
          type="submit"
          className="btn btn-primary"
          disabled={!file || loading || profilerAccessStore.isProfilerDemo}
          onClick={() => onSearch(file)}
        >
          Search
        </button>
      </div>
    );
  }
);

export default ProfilerCompanyBulkSearchFormMobile;
